const CheckboxMaterial = (props) => {
  return (
    <div className="pd-material__checkbox pd-material__checkbox--svg">
      <input
        className="pd-material__checkbox__input sr-only"
        type="checkbox"
        required={props.required}
        name={props.name}
        id={props.name}
      />
      <label
        className="pd-material__checkbox__label pd-material__checkbox__label--svg"
        htmlFor={props.name}
      >
        <svg viewBox="0 0 100 100">
          <path
            className="path"
            fill="none"
            stroke="#000"
            strokeWidth="13"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="M12.1 52.1l24.4 24.4 53-53"
          />
        </svg>
        <span className="pd-material__checkbox__label__text">
          {props.children}
        </span>
      </label>
    </div>
  );
};

export default CheckboxMaterial;
